// extracted by mini-css-extract-plugin
export var label = "_jf-2";
export var slideContainer = "_jf-0";
export var slider = "_jf-1";